import { Text } from '@contentful/rich-text-types';
import { MarketingCardFields } from '@ts/contentful';
import { InteractiveCardProps } from '@ts/components';

function parseMarketingCards(
	interactiveCards: MarketingCardFields[],
	interactiveCardProps?: InteractiveCardProps | undefined
): { cardLocations: Array<number>; cardsByLocation: Record<number, InteractiveCardProps> } {
	const cardLocations = interactiveCards?.map(card => card.blockLocation - 1);
	const cardsByLocation: Record<number, InteractiveCardProps> = interactiveCards?.reduce<Record<number, InteractiveCardProps>>(
		(acc, card) => {
			const text = card.text?.content?.[0]?.content?.[0] as Text;
			acc[card.blockLocation - 1] = {
				'key': card.title,
				'background': card?.background?.url,
				'title': card.title,
				'text': text?.value,
				'subtitle': card.subtitle,
				'subheading': !card.shouldExpand ? text?.value : '',
				'shouldExpand': card.shouldExpand,
				'button1': {
					label: card.buttonLabel1,
					link: card.buttonLink1,
					color: card.buttonColor1,
					fullWidth: true,
				},
				...(card.buttonLabel2 && {
					button2: {
						label: card.buttonLabel2,
						link: card.buttonLink2,
						color: card.buttonColor2,
					},
				}),
				// eslint-disable-next-line @typescript-eslint/ban-ts-comment
				// @ts-ignore
				'data-base-frame-marketing-block': card.title,
				'size': 'flexible',
				...(!!interactiveCardProps ? interactiveCardProps : {}),
			};
			return acc;
		},
		{}
	);

	return {
		cardLocations,
		cardsByLocation,
	};
}

export default parseMarketingCards;
